import React, {ReactFragment} from 'react';

import type * as RunFeed from '../../../util/runfeed';

type TableEditorColumnsProps = {
  config: RunFeed.Config;
  fixedColumns: string[];
  hiddenColumns: string[];
  highlightColumn: (column: string) => ReactFragment;
  pinnedColumns: string[];
  update(config: RunFeed.Config): void;
  visibleColumns: string[];
};

export function TableEditorColumns({
  config,
  fixedColumns,
  hiddenColumns,
  highlightColumn,
  pinnedColumns,
  update,
  visibleColumns,
}: TableEditorColumnsProps) {
  return <div>tbd</div>;
}
